
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tns",
      function () {
        return require("private-next-pages/tns.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tns"])
      });
    }
  